import React from 'react';

const PrimeMinister = () => {
  const sectionTitleStyle = {
      color: '#003366', 
      borderBottom: '2px solid #003366', 
      paddingBottom: '10px', 
      marginBottom: '20px',
      fontSize: '18px',
      fontFamily: 'serif',
      textTransform: 'uppercase'
  };

  return (
    <div className="container mt-5 mb-5">
      <div className="row">
        
        {/* === LEFT COLUMN: Sidebar Menu === */}
        <div className="col-lg-3">
            <h4 style={sectionTitleStyle}>GOVERNMENT</h4>
            <div className="list-group list-group-flush">
                <a href="#" className="list-group-item list-group-item-action text-secondary border-0 ps-0">
                    <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> Cabinet of Ministers
                </a>
                <a href="#" className="list-group-item list-group-item-action text-secondary border-0 ps-0">
                    <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> Deputy Prime Minister for reintegration
                </a>
                <a href="#" className="list-group-item list-group-item-action text-secondary border-0 ps-0">
                    <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> Deputy Prime Minister for Digitization
                </a>
                <a href="#" className="list-group-item list-group-item-action text-secondary border-0 ps-0">
                    <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> Central administrative authorities
                </a>
                 <a href="#" className="list-group-item list-group-item-action text-secondary border-0 ps-0">
                    <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> Public institutions subordinated to the Government
                </a>
                <a href="#" className="list-group-item list-group-item-action text-secondary border-0 ps-0">
                    <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> Online Government meetings
                </a>
                 <a href="#" className="list-group-item list-group-item-action text-secondary border-0 ps-0">
                    <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> Government legal framework
                </a>
            </div>
        </div>

        {/* === CENTER COLUMN: Prime Minister Content === */}
        <div className="col-lg-6">
            <h4 style={sectionTitleStyle}>PRIME MINISTER OF THE REPUBLIC OF MOLDOVA</h4>

            {/* Profile Card */}
            <div className="d-flex mb-3">
                 {/* Left Image Part */}
                 <div className="position-relative" style={{width: '280px', flexShrink: 0}}>
                    <img src="/images/20251229-1ES_5784.jpg" className="img-fluid" alt="Dorin Recean"/>
                    {/* Blue Overlay content inside image if needed, or keep it clean like the design */}
                 </div>
                 
                 {/* Right Text Part */}
                 <div className="ps-4 pt-4">
                     <h4 className="text-uppercase" style={{color:'#003366', fontFamily:'serif'}}>DORIN RECEAN</h4>
                     <p className="text-muted">Prime Minister of the Republic of Moldova</p>
                 </div>
            </div>

            {/* Metadata Row */}
            <div className="d-flex align-items-center text-muted small border-top pt-2">
                <div className="me-4"><i className="fa fa-calendar me-1"></i> 30-03-2016 10:39</div>
                <div className="me-auto"><i className="fa fa-eye me-1"></i> 106,733</div>
                
                {/* Flags */}
                <div className="d-flex gap-2">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/2/27/Flag_of_Moldova.svg" width="20" alt="MD"/>
                    <img src="https://upload.wikimedia.org/wikipedia/en/f/f3/Flag_of_Russia.svg" width="20" alt="RU"/>
                </div>
            </div>

        </div>

        {/* === RIGHT COLUMN: Agenda & Widget === */}
        <div className="col-lg-3">
            <h4 style={sectionTitleStyle}>AGENDA</h4>
            
            {/* Calendar Widget */}
            <div className="bg-white border rounded shadow-sm p-0 mb-4">
                <div className="d-flex justify-content-between align-items-center text-white p-2" style={{backgroundColor: '#003366'}}>
                    <button className="btn btn-sm text-white"><i className="fa fa-chevron-left"></i></button>
                    <span className="fw-bold">January 2026</span>
                    <button className="btn btn-sm text-white"><i className="fa fa-chevron-right"></i></button>
                </div>
                <div className="p-2">
                    <table className="table table-sm text-center border-0 mb-0" style={{fontSize: '12px'}}>
                        <thead>
                            <tr className="text-primary fw-bold">
                                <th>M</th><th>T</th><th>W</th><th>T</th><th>F</th><th>S</th><th>S</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td></td><td></td><td></td><td className="text-danger fw-bold border border-danger">1</td><td>2</td><td>3</td><td>4</td></tr>
                            <tr><td>5</td><td>6</td><td>7</td><td>8</td><td>9</td><td>10</td><td>11</td></tr>
                            <tr><td>12</td><td>13</td><td>14</td><td>15</td><td>16</td><td>17</td><td>18</td></tr>
                            <tr><td>19</td><td>20</td><td>21</td><td>22</td><td>23</td><td>24</td><td>25</td></tr>
                            <tr><td>26</td><td>27</td><td>28</td><td>29</td><td>30</td><td>31</td><td></td></tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Blue Bubble Widget */}
            <div className="d-flex justify-content-end mt-5">
                <div className="position-relative text-end" style={{maxWidth:'200px'}}>
                    <div className="bg-primary text-white p-3 rounded shadow" style={{backgroundColor: '#336699 !important', fontSize:'12px'}}>
                         <div className="d-flex justify-content-between">
                            <strong>EUROPA PENTRU TINE!</strong>
                            <i className="fa fa-times-circle" style={{cursor:'pointer'}}></i>
                         </div>
                        Află despre beneficiile și oportunitățile oferite Republicii Moldova de Uniunea Europeană.
                    </div>
                    <div style={{
                        width: 0, height: 0, 
                        borderLeft: '10px solid transparent', 
                        borderRight: '10px solid transparent', 
                        borderTop: '15px solid #0d6efd', 
                        marginLeft: 'auto', marginRight: '20px'
                    }}></div>
                    <img src="/images/plan_eu.png" className="rounded-circle mt-2 shadow" width="60" alt="EU"/>
                </div>
            </div>
        </div>

      </div>
    </div>
  );
};

export default PrimeMinister;